import React from 'react';
import { Tag, Tooltip } from 'antd';
import { SUPPORT_TAGS } from '../constants';

interface TaskTagProps {
    tag: string;
    closable?: boolean;
    onClose?: (e: React.MouseEvent) => void;
    style?: React.CSSProperties;
}

const getTagTooltip = (tag: string): string => {
    switch (tag) {
        case SUPPORT_TAGS.frontend:
            return 'Задачи, связанные с созданием внешнего вида сайта или приложения, например, дизайн кнопок, страниц и удобство использования';
        case SUPPORT_TAGS.backend:
            return 'Задачи, связанные с работой серверов, баз данных и внутренней логикой, которые обеспечивают функционирование сайта или приложения';
        case SUPPORT_TAGS.question:
            return 'Вопросы или запросы, требующие объяснения или уточнения';
        case SUPPORT_TAGS.task:
            return 'Конкретные задания, которые нужно выполнить';
        default:
            return tag;
    }
};

const getTagColor = (tag: string): string => {
    switch (tag) {
        case SUPPORT_TAGS.frontend:
            return 'cyan';
        case SUPPORT_TAGS.backend:
            return 'purple';
        case SUPPORT_TAGS.question:
            return 'yellow';
        case SUPPORT_TAGS.task:
            return 'green';
        case SUPPORT_TAGS.other:
            return 'gray';
        default:
            return 'blue';
    }
};

const TaskTag: React.FC<TaskTagProps> = ({ tag, closable, onClose, style }) => {
    return (
        <Tooltip
            title={getTagTooltip(tag)}
            placement="top"
        >
            <Tag
                className="task-tag"
                style={style}
                color={getTagColor(tag)}
                closable={closable}
                onClose={onClose}
            >
                { tag }
            </Tag>
        </Tooltip>
    );
};

export default TaskTag;
